import { render, staticRenderFns } from "./AddOnForm.vue?vue&type=template&id=a44966d0"
import script from "./AddOnForm.ts?vue&type=script&lang=ts&external"
export * from "./AddOnForm.ts?vue&type=script&lang=ts&external"
import style0 from "./AddOnForm.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports